import { render } from "./mcard.vue?vue&type=template&id=4be168fc&scoped=true"
const script = {}

import "./mcard.vue?vue&type=style&index=0&id=4be168fc&lang=scss&scoped=true"

import exportComponent from "D:\\wwwroot\\mld\\vue-source\\mileIsland\\node_modules\\.store\\vue-loader@16.8.3\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4be168fc"]])

export default __exports__